import { render, staticRenderFns } from "./Db.vue?vue&type=template&id=2f82c204"
import script from "./Db.vue?vue&type=script&lang=js"
export * from "./Db.vue?vue&type=script&lang=js"
import style0 from "./Db.vue?vue&type=style&index=0&id=2f82c204&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports